/**
 * Procedure Categories and Procedures for MD in Marine Medicine students
 * Extracted with strict evidence from official NMC PDF (Page 26: "Skills to be acquired during the training period")
 */
export const MARINE_MEDICINE_PROCEDURES = {
  "Hyperbaric & Maritime Operational Procedures": [
    "Hyperbaric Oxygen Therapy (HBOT) Administration",
    "Hyperbaric Chamber Operation, Diagnostics & Monitoring",
    "Chamber Emergency & Safety Procedures",
    "Pulmonary Function Testing (PFT)",
    "Pure Tone Audiometry & Stress Testing (TMT)",
  ],
  "Emergency, Airway & Resuscitation Procedures": [
    "Assisted Ventilation & Endotracheal Intubation",
    "Emergency Intravenous Cannula Insertion & Venous Cut Down",
    "Cardioversion, Defibrillation & External Pacemaking",
    "Thoracocentesis & Intercostal Drainage",
    "Gastric Lavage & Nasogastric Intubation",
    "Lumbar Puncture",
    "Aerosol Nebuliser Administration & Oxygen Support",
  ],
  "Surgical, Anaesthetic & Dental Emergency Procedures": [
    "Wound Debridement & Cleansing Procedures (Including Thermal Burns)",
    "Local & Topical Anaesthesia Administration",
    "Basic Dental Emergency Procedures (Including Extractions)",
  ],
};

export const MARINE_MEDICINE_CATEGORIES = Object.keys(MARINE_MEDICINE_PROCEDURES);

export const isMDInMarineMedicineDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return d.includes("marine medicine") || d.includes("marine") || d.includes("maritime");
};
